import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import useSearchHooks from '../../../store/hotel/search-hooks';

export default function BudgetSelection() {
  const { setBudgetStart, setBudgetEnd, search } = useSearchHooks();
  return (
    <div className="rs_form_row rs_autosuggest_row rs_1365_100 rs_autosuggest Budget">
      <FontAwesomeIcon icon={faMoneyBill} className="fa-location-icon" />
      <p className={search.budgetStart || search.budgetEnd ? 'hide-placeholder d-block' : 'hide-placeholder '}>Budget per Night</p>
      <div style={{ paddingTop: search.budgetStart || search.budgetEnd ? '13px' : '5px' }}>
        $
        <input
          name="query"
          className={search.budgetStart ? 'rs_autosuggest_acts' : ''}
          type="text"
          title="Enter a start budget"
          autoComplete="off"
          value={search.budgetStart}
          onChange={(e) => {
            setBudgetStart({ budgetStart: e.target.value });
          }}
          placeholder="Budget"
        />
        {!search.budgetStart ? (
          ''
        ) : (
          <div style={{ textAlign: 'left' }}>
            - $
            <input
              name="query"
              className={search.budgetEnd ? 'rs_autosuggest_acts' : ''}
              type="text"
              title="Enter a end Budget"
              autoComplete="off"
              value={search.budgetEnd}
              onChange={(e) => {
                setBudgetEnd({ budgetEnd: e.target.value });
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
